
import { Types } from '#adapter/api/campaigns/v2/recom/supplier-products';
import { IGood } from '#core/types/goods';

import { TItemOrUndefined } from './components/section-goods/slice';
import { DEFAULT_CPO_BUDGET_MULTIPLIER } from './const';

export const formatProductData = (data: Types.IAuctionSearchBarData['products']) => {
    return data?.map((product) => ({
        nm      : product.nm,
        brand   : product.brand?.name,
        name    : product.name,
        priority: product.priority,
        minCPO  : product.minCpo,
        cpmRec  : product.cpmRec
    })) as Array<IGood>;
};

export const findBiggestBet = (itemsList: Array<TItemOrUndefined>) => {
    return itemsList.reduce((max, item) => (item ? (Math.max(max, item?.bet ?? 0)) : max), 0);
};

export const calculateMinCPOBudget = (biggestBet: number, multiplier: number = DEFAULT_CPO_BUDGET_MULTIPLIER) => {
    return biggestBet * multiplier;
};
